import React, { Component } from 'react'

class RoosChart extends Component {
    constructor(props) {
        super(props)

        const { store } = props

        store.onSave = this.save
    }

    save = () => ({
        id: 'roos-chart',
    })

    render() {
        return (
            <div>Template for ROOS charting</div>
        )
    }
}

export default RoosChart
